import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function AdminLogin() {
    const { login, admin, loading } = useAuth();
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [busy, setBusy] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (!loading && admin) navigate("/admin/dashboard");
    }, [admin, loading, navigate]);

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setBusy(true);
        try {
            await login(email, password);
            navigate("/admin/dashboard");
        } catch (err) {
            setError(err.response?.data?.detail || "Invalid email or password");
        } finally {
            setBusy(false);
        }
    };

    const inputCls = "w-full border border-border bg-transparent px-4 py-3 text-sm focus:outline-none focus:border-primary focus:ring-1 focus:ring-primary";

    return (
        <div className="min-h-screen flex items-center justify-center bg-foreground grain px-4" data-testid="admin-login-page">
            <div className="w-full max-w-md bg-background p-10">
                <div className="flex items-center gap-3 mb-8">
                    <div className="w-11 h-11 bg-primary text-primary-foreground flex items-center justify-center font-heading font-black text-xl">Y</div>
                    <div>
                        <div className="font-heading font-black text-xl">YATTO LLC</div>
                        <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">Admin Portal</div>
                    </div>
                </div>
                <h1 className="font-heading font-bold text-2xl mb-6 flex items-center gap-2"><Lock size={20} /> Sign in</h1>
                <form onSubmit={submit}>
                    <div className="mb-4">
                        <label className="text-xs uppercase tracking-wider text-muted-foreground">Email</label>
                        <input className={inputCls} type="email" value={email} onChange={(e) => setEmail(e.target.value)} data-testid="admin-email" />
                    </div>
                    <div className="mb-4">
                        <label className="text-xs uppercase tracking-wider text-muted-foreground">Password</label>
                        <input className={inputCls} type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="admin-password" />
                    </div>
                    {error && <p className="text-sm text-destructive mb-4" data-testid="admin-error">{error}</p>}
                    <button type="submit" disabled={busy} data-testid="admin-login-btn" className="w-full flex items-center justify-center gap-2 bg-primary text-primary-foreground px-6 py-3.5 font-semibold hover:bg-secondary hover:text-secondary-foreground transition-colors disabled:opacity-60">
                        {busy ? "Signing in..." : <>Sign In <ArrowRight size={17} /></>}
                    </button>
                </form>
            </div>
        </div>
    );
}
